module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-180x180-a579b1bb9fcc679d1d4f2a0bcfa0a919.png";